import React from 'react';
import { Link } from 'gatsby';
import Layout from '../../components/layout';
import MetaData from '../../components/meta-data';
import Breadcrumbs from '../../components/breadcrumbs';
import Tiles from '../../components/tiles';
var PhotosIndex = function PhotosIndex(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3, _props$data$travel$ed, _props$data$food$edge, _props$data$paintball, _props$data$cars$edge, _props$data$people$ed, _props$data$projects$;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Travel Photos",
        description: "Some photos that I've taken while traveling.  My hopes is that this gallery fills up quicker than the rest.",
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement("h1", null, "Photos"), /*#__PURE__*/ React.createElement("p", null, "Thanks for taking a look at my photos. I've been taking photos \"professionally\" since 2007 and I really enjoy capturing special moments, especially when they are of family and friends and you can give them your photos and see the happiness it brings them.")), /*#__PURE__*/ React.createElement(Tiles, {
        grid: true,
        tiles: [{
                id: props.data.travel.edges[0].node.id,
                image: {
                    fluid: (_props$data$travel$ed = props.data.travel.edges[0].node.childImageSharp) === null || _props$data$travel$ed === void 0 ? void 0 : _props$data$travel$ed.fluid
                },
                link: '/photos/travel/',
                copy: {
                    headline: {
                        h1: 'Travels'
                    }
                }
            }, {
                id: props.data.food.edges[0].node.id,
                image: {
                    fluid: (_props$data$food$edge = props.data.food.edges[0].node.childImageSharp) === null || _props$data$food$edge === void 0 ? void 0 : _props$data$food$edge.fluid
                },
                link: '/photos/food/',
                copy: {
                    headline: {
                        h1: 'F🤤🤤D'
                    }
                }
            }, {
                id: props.data.paintball.edges[0].node.id,
                image: {
                    fluid: (_props$data$paintball = props.data.paintball.edges[0].node.childImageSharp) === null || _props$data$paintball === void 0 ? void 0 : _props$data$paintball.fluid
                },
                link: '/photos/paintball/',
                copy: {
                    headline: {
                        h1: 'Paintball'
                    }
                }
            }, {
                id: props.data.cars.edges[0].node.id,
                image: {
                    fluid: (_props$data$cars$edge = props.data.cars.edges[0].node.childImageSharp) === null || _props$data$cars$edge === void 0 ? void 0 : _props$data$cars$edge.fluid
                },
                link: '/photos/cars/',
                copy: {
                    headline: {
                        h1: 'Cars'
                    }
                }
            }, {
                id: props.data.people.edges[0].node.id,
                image: {
                    fluid: (_props$data$people$ed = props.data.people.edges[0].node.childImageSharp) === null || _props$data$people$ed === void 0 ? void 0 : _props$data$people$ed.fluid
                },
                link: '/photos/people/',
                copy: {
                    headline: {
                        h1: 'People'
                    }
                }
            }, {
                id: props.data.projects.edges[0].node.id,
                image: {
                    fluid: (_props$data$projects$ = props.data.projects.edges[0].node.childImageSharp) === null || _props$data$projects$ === void 0 ? void 0 : _props$data$projects$.fluid,
                    altText: 'Drew Templeton Project Photos'
                },
                link: '/photos/projects/',
                copy: {
                    headline: {
                        h1: 'Projects'
                    }
                }
            }]
    }), /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "photos/"
    }, /*#__PURE__*/ React.createElement("h1", null, "Interested In Working Together?")), /*#__PURE__*/ React.createElement("p", null, "Some looks at my most recent photos. If you're looking to hire a photographer. I enjoy all different types of shoots; portraits, product, lifestyle, food and cars. Feel free to contact me if you'd like to work together."), /*#__PURE__*/ React.createElement("a", {
        href: "mailto:drew@drewtempleton.com"
    }, /*#__PURE__*/ React.createElement("button", null, "Contact Me")))));
};
export default PhotosIndex;
var query = "3380095390";
